<template>
	<div class="personBox">
		<div class="backBtn" @click="onClickLeft"><van-icon name="arrow-left" /></div>
		<!-- <div class="iconBtn" v-if="userInfo && userInfo.superUserId" @click="handleLogout">
			{{ $t('personal.loginOut') }}
		</div>
		<div class="iconBtn" v-else @click="handleLogin">
			{{ $t('personal.loginBtn') }}
		</div> -->
		<div class="cardBox">
			<!-- <div class="avatar">
				<img v-if="userInfo.picture" :src="userInfo.picture" :onerror="imgError">
				<img v-else src="~@/assets/images/common/avatar_temp.png" />
			</div> -->
			<!-- <div class="vipDetail">
				<router-link to="/home/recommend">{{ $t('personal.vipDetail') }}＞</router-link>
			</div> -->
				<div class="leftTitle" @click="showTip">VIP규칙</div>
				<div class="vipIconBox">
					<van-image
						width="40%"
						style="padding-top: 1.5rem;padding-bottom: 1.5rem;"
						:src="require('@/assets/images/common/vipIcon.png')"
					/>
					<div class="vipRightIconBox">
						<div class="vipRightIcon">
							<span style="padding-left: 1.8rem;font-size: 0.6rem;" v-if="vipLevel == 'vip0'">{{ $t('personal.commonUser') }}</span>
							<span style="padding-left: 2.2rem;" v-else>{{vipLevel}}</span>
						</div>
						<div class="progressBar">
							<div class="proNow" :style="{width:proNow + '%'}"></div>
						</div>
						<div class="vipTip">
							<!-- 다음 VIP 등급까지 {{needInt}} 포인트 남았습니다 -->
							{{ $t('footer.levelTips', { nums: needInt }) }}
						</div>
						<div class="vipDesc">
							<!-- 이 플랫폼에서 GM 코인을 충전하면 포인트를 얻을 수 있으며, 1위안 충전 시 1 성장 값을 얻을 수 있습니다. -->
							<p>{{ $t('footer.ruleTips1') }}</p>
							<p>{{ $t('footer.ruleTips2') }}</p>
							<p>{{ $t('footer.ruleTips3') }}</p>
							<p>{{ $t('footer.ruleTips4') }}</p>
							<p>{{ $t('footer.ruleTips5') }}</p>
						</div>
					</div>
				</div>
			<!-- <van-cell center :label="`${$t('personal.googleEmail')}：${userInfo.email || '***'}`" is-link to="/infos">
				<template #title>
				    <span class="titleLabel">{{ $t('personal.platId') }}：</span>
				    <span class="titleVal">{{ userInfo.superUserId || '***' }}</span>
				  </template>
			  </van-cell> -->
			  <!-- <div class="lineBox">
				<div class="coinLine">
					<i class="coinIcon"></i>
					<p>{{ $t('personal.platCoin') }}：{{ userInfo.platCoin || 0 }}</p>
				</div>
			  </div> -->
		</div>
		
		<div class="footDesc">
			<div class="giftList">
				<div class="giftItem" v-for="(item, index) in giftList" :key="index">
					<div class="giftLeft">
						<div class="giftTitle">
							<span>{{ item.vipLevel }}</span>
						</div>
					</div>
					<div class="propsBox">
						<div class="propItem" v-for="(prop, pIndex) in item.vipRuleAwardConfigs" :key="pIndex">
							<div class="propBg" :class="{ got: prop.isGet === 1 }">
								<img :src="getPropImg(prop)" class="propImg" @click="showPropName(prop)" />
							</div>
							<span class="propName" :class="{ got: prop.isGet === 1 }">{{ getPropName(prop) }}</span>
						</div>
					</div>
					<div class="claimBtnBox" v-if="!item.vipRuleAwardConfigs.every(p => p.isGet === 1)">
						<div class="claimBtn" :class="{ disabled: item.vipRuleAwardConfigs.some(p => p.isGet === -1) }" @click="!item.vipRuleAwardConfigs.some(p => p.isGet === -1) && handleClaim(item)">
							보상 수령
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 登录 -->
		<Login :showLogin="openLogin" @loginSuccess="loginSuccess" />
		
		<van-popup v-model:show="tipFlag" round teleport="body" :close-on-click-overlay="false" >
			<div class="guidesBox" v-if="tipFlag">
				<div style="max-height: 70vh;overflow-y: scroll;">
					<div class="tipDescTitle">
						VIP 규칙
					</div>
					<div class="tipDesc">
						<p>1.플레이어가 게임에 접속하여 GM 출석 체크를 하면 기본 보상으로 200GM 코인을 얻을 수 있습니다.
						</p>
						<p>2.공식 패키지로 충전하면 VIP 등급을 올릴 수 있으며, 해당 VIP 등급에 따라 출석 시 GM 코인 배수 보상을 받을 수 있습니다.
						</p>
						<p>3.예를 들어, VIP8이 출석 체크를 할 경우 (VIP8은 1-5배 보상을 랜덤으로 받을 수 있음) 200 * (1-5 랜덤 배수) = 800(4배) GM 코인을 받을 수 있습니다.
						</p>
					</div>
					<div class="btnBox" @click="handleSteps">
						확인
					</div>
				</div>
			</div>
		</van-popup>
		
	</div>
</template>

<script setup>
	import { getCurrentInstance,onMounted,onBeforeMount,ref,watch,computed } from 'vue'
	import { useRouter } from 'vue-router'
	import useUserStore from '@/store/modules/user'
	import useConfigStore from '@/store/modules/config'
	import Login from '@/components/login'
	import { propUserLogin,getVipInfo, getVipPropList, getVipProp, getUserLevel } from '@/api/gm.js'
	
	const { proxy } = getCurrentInstance();
	const isMobile = computed(() => {
		return useConfigStore().isMobile
	})
	const userInfo = computed(() => {
		return useUserStore().userInfo
	})
	const router = useRouter();
	const openLogin = ref(false)
	const tipFlag = ref(false)
	const vipLevel = ref('VIP')
	const needInt = ref('xxx')
	const proNow = ref(0)
	const giftList = ref([])
	const userLevelData = ref(null)
	const handleClaim = (item) => {
		getVipProp({ remarks: item.ruleId }).then((res) => {
			if(res.code === 200){
				proxy.$toast('수령 성공')
				getVipPropList().then((res)=>{
					giftList.value = res.data || []
				})
			} else {
				proxy.$toast(res.msg || '수령 실패')
			}
		}).catch(() => {
			openLogin.value = true
		})
	}
	const showPropName = (prop) => {
		proxy.$toast(getPropName(prop))
	}
	const getPropName = (prop) => {
		const typeMap = { 0: '반값 할인 GM 코인', 1: '전액 할인 GM 코인', 3: 'GM 교환 쿠폰' }
		return typeMap[prop.type] || '아이템'
	}
	const getPropImg = (prop) => {
		const imgMap = {
			0: require('@/assets/images/kr/vipPropHalf.png'),
			1: require('@/assets/images/kr/vipPropFull.png'),
			3: require('@/assets/images/kr/vipGMProp.png')
		}
		return imgMap[prop.type] || ''
	}
	const handleLogin = () => {
		openLogin.value = true
	}
	const loginSuccess = () => {
		openLogin.value = false
		if(useUserStore().userInfo.superUserId){
			if(userInfo.value.picture){
				getVipInfo(userInfo.value.superUserId).then((res)=>{
					vipLevel.value = res.data.vipLevel
					needInt.value = res.data.vipRule.maxIntegral - res.data.integral
					proNow.value = res.data.progressBar
				}).catch(() => { openLogin.value = true })
			}
			getVipPropList().then((res)=>{
				giftList.value = res.data || []
			}).catch(() => { openLogin.value = true })
		}
	}
	const handleLogout = () => {
		useUserStore().close().then(() => {
			proxy.$toast('Success')
		})
	}
	const onClickLeft = () => {
		history.back()
	}
	const showTip = () => {
		tipFlag.value = true
	}
	const handleSteps = () => {
		tipFlag.value = false
	}
	const handleRecharge = () => {
		router.push({ path:'/recharge' });
	}
	const imgError = () => {
		var img = event.srcElement;
		img.src = require('@/assets/images/common/avatar_temp.png');
		img.onerror = null;
	}
	const toVipDetail = () =>{
		console.log(1111);
	}
	onMounted(() => {
		const query = router.currentRoute.value.query
		if(query.token){
			propUserLogin(query.token).then((res) => {
				console.log(res)
				useUserStore().setInfo(res.data).then((datas) => {
					proxy.$toast('Success')
					if(userInfo.value.picture){
						getVipInfo(useUserStore().userInfo.superUserId).then((res)=>{
							vipLevel.value = res.data.vipLevel
							needInt.value = res.data.vipRule.maxIntegral - res.data.integral
							proNow.value = res.data.progressBar
						}).catch(() => { openLogin.value = true })
					}
					getVipPropList().then((res)=>{
						giftList.value = res.data || []
					}).catch(() => { openLogin.value = true })
				})
			}).catch((err) => {
				openLogin.value = true
			})
			return
		}
		if(!useUserStore().userInfo.superUserId){
			openLogin.value = true
			return
		}
		if(userInfo.value.picture){
			getVipInfo(userInfo.value.superUserId).then((res)=>{
				// vipLevel/proNow/needInt 由 getUserLevel 统一管理
			})
		}
		getVipPropList().then((res)=>{
			giftList.value = res.data || []
		}).catch(() => { openLogin.value = true })
		getUserLevel().then((res)=>{
			userLevelData.value = res.data
			vipLevel.value = res.data.vipLevel || 'VIP'
			const integral = res.data.integral || 0
			const nextIntegral = res.data.nextIntegral || 1
			proNow.value = Math.min(100, Math.round((integral / nextIntegral) * 100))
			needInt.value = Math.max(0, nextIntegral - integral)
		}).catch(() => { openLogin.value = true })
		
	})
	watch(isMobile, (newVal, oldVal) => {
		if(!newVal){
			router.push({ path:'/' });
		}
	},{ immediate: true })
</script>


<style lang="less" scoped>
	.tipDescTitle{
		font-size: 1.2rem;
		margin-bottom: 1rem;
		font-weight: bolder;
	}
	.tipDesc{
		color: #426667;
		text-align: justify; 
		font-size: 0.9rem;
		line-height: 1.4rem;
	}
	a{
		color: #000;
	  &::after{
	      content: '';display: block;width: 0;height: 2px;background: #51bac0;position: absolute;bottom: 0;left: 50%;transition: all 0.3s ease-in-out;
	  }
	  &:hover{
	      color: #51bac0;
	      &::after{width: 100%;left: 0;}
	    }
	  &.router-link-active{
	      color: #51bac0;
	      &:hover{color: #000000;}
	    }
	  
	}
	.giftList{
		padding: 0.5rem 1rem;
		.giftItem{
			position: relative;
			background: url('~@/assets/images/kr/vipgift.png') no-repeat center / 100% 100%;
			padding: 0.6rem 0.5rem;
			margin-bottom: 0.7rem;
			min-height: 4.5rem;
		}
		.giftTitle{
			position: absolute;
			top: 0.35rem;left: 2.3rem;
			display: flex;align-items: center;
			z-index: 2;
			span{font-size: 0.85rem;color: #fff;line-height: 1.2;font-weight: 600;}
		}
		.propsBox{display: flex;gap: 0.25rem;flex-wrap: wrap;padding-top: 1.4rem;align-items: flex-start;}
		.propItem{flex-shrink: 0;display: flex;flex-direction: column;align-items: center;}
		.propBg{
			background: url('~@/assets/images/kr/vipgiftbg.png') no-repeat center / 100% 100%;
			display: flex;align-items: center;justify-content: center;
			padding: 0.2rem;border-radius: 4px;width: 2.6rem;height: 2.6rem;
			.propImg{width: 1.8rem;height: 1.8rem;cursor: pointer;}
		}
		.propName{font-size: 0.45rem;color: #333;margin-top: 0.15rem;text-align: center;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 2.6rem;line-height: 1.1;}
		.claimBtnBox{
			position: absolute;right: 0.5rem;top: 50%;transform: translateY(-50%);
		}
		.claimBtn{
			width: 5rem;height: 2.6rem;background: url('~@/assets/images/kr/vipgetprop.png') no-repeat center / contain;
			display: flex;align-items: center;justify-content: center;
			font-size: 0.8rem;color: #fff;font-weight: bold;cursor: pointer;
			&.disabled{opacity: 0.4;filter: grayscale(100%);cursor: not-allowed;}
		}
	}
	
</style>
<style lang="less" scoped>
	.backBtn{
		color: #b3ffdc;
		position: absolute;
		top: 4%;
	}
	.personBox{
		background: url('~@/assets/images/common/personal_up_bg.png') no-repeat top;
		background-size: 100%;overflow-y: scroll;
		padding: 6rem 1rem 0;box-sizing: border-box;position: relative;
		.footDesc{
			background: #fff;width: calc(100% + 2rem);margin-left: -1rem;margin-top: 4rem;
			height: calc(100vh - 360px);overflow-y: scroll;min-height: 6.25rem;padding-bottom: 3.125rem;box-sizing: border-box;
		}
		.iconBtn{
			position: absolute;top: 1.25rem;right: 1rem;color: #fff;font-size: 0.9375rem;
		}
		.cardBox{
			background: url('~@/assets/images/common/vipLeftBacV.png') no-repeat center top;
			background-size: 100% 100%;
			height: 11rem;
			width: 100%;border-radius: 0.5rem;position: relative;
			.avatar{
				position: absolute;left: 1.875rem;top: -2rem;z-index: 111;
				width: 4rem;height: 4rem;border: 0.125rem solid #fff;border-radius: 50%;overflow: hidden;
				img{
					width: 100%;
				}
			}
			.leftTitle{
				top: 5%;
				position: absolute;
				right: 1%;
				color: white;
				width: 5rem;
				text-align: center;
			}
			.vipIconBox{
				width: 90%;
				padding-top: 1rem;
				margin: 0 auto;
				display: flex;height: 80%;
			}
			.vipRightIconBox{
				width: 80%;position: relative;
				.vipRightIcon{
					color: #f4f4f4;
					background: url('~@/assets/images/common/vipLevelIcon.png') no-repeat center;
					background-size: 100%;
					position: unset;
					width: 5.2rem;
					font-size: 0.8rem;
					height: 1.6rem;
					margin-top: 0.2rem;
					margin-left: 0.8rem;
					line-height: 1.4rem;
				}
				.progressBar{
					margin-top: 0.4rem;
					width: 85%;
					border-radius:20px;
					background-color: #f8f8f8;
					margin-left: 1rem;
					border: 1px solid #f3ae4e;
					height: 0.4em;
					.proNow{height: 100%;border-radius:20px;background: linear-gradient(to right, #f3ae4e, #ff5b1a);transition: width 0.3s ease;}
				}
				.vipTip{
					font-size: 0.65rem;
					color: #be843a;
					padding-left: 1rem;
					margin-top: 0.2rem;
				}
				.vipDesc{
					font-size: 0.72rem;
					padding-left: 1.2rem;
					margin-top: 0.875rem;
					color: #ff5b1a;
					height: 44%;overflow-y: scroll;
				}
			}
			.vipIcon{
				width: 4.2rem;
				height: 1.6rem;
				text-align: center;
				line-height:1.6rem;
				padding-left: 1.2rem;
				color: #f4f4f4;
				font-size: 0.8rem;
				position: absolute;
				left: 28%;
				top: 1%;
				background: url('~@/assets/images/common/vipLevelIcon.png') no-repeat center;
				background-size: 100%;
			}
			.vipDetail{
				font-size: 0.8rem;
				position: absolute;
				right:2%;
				line-height: 1.5rem;
				top: 2%;
				color: #000;
			}
			.lineBox{
				padding: 0 1rem 1rem;box-sizing: border-box;margin: 0.75rem 0;
			}
			.coinLine{
				display: flex;align-items: center;justify-content: center;
				padding: 0.75rem 0.75rem;
				background: url('~@/assets/images/common/line_bg.png') no-repeat center;
				background-size: 100%;
				.coinIcon{
					display: inline-block;width: 1.25rem;height: 1.25rem;
					background: url('~@/assets/images/common/coin_icon.png') no-repeat center;
					background-size: 100%;flex-shrink: 0;margin-right: 0.3125rem;
				}
				p{
					flex: 1;font-size: 0.875rem;
				}
				.rechargeBtn{
					flex-shrink: 0;
					font-size: 0.875rem;
					background: linear-gradient(to right,#51BAC0,#85D6DA);color: #fff;
					padding: 0.25rem 1.25rem;border-radius: 0.3125rem;
				}
			}
			/deep/.van-cell:after{
				border-bottom: none;
			}
		}
	}
</style>
